import { render, staticRenderFns } from "./FilteringSummary.vue?vue&type=template&id=452605d2&scoped=true&"
import script from "./FilteringSummary.vue?vue&type=script&lang=js&"
export * from "./FilteringSummary.vue?vue&type=script&lang=js&"
import style0 from "./FilteringSummary.vue?vue&type=style&index=0&id=452605d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452605d2",
  null
  
)

export default component.exports